import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import './index.css';
import App from './App.jsx';
import { ThemeProvider } from './contexts/ThemeContext.jsx';
import { I18nProvider } from './i18n/index.jsx';
import { initAnalytics } from './utils/analytics';

initAnalytics();

const CLERK_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || '';

const root = ReactDOM.createRoot(document.getElementById('root'));

if (CLERK_KEY) {
  root.render(
    <React.StrictMode>
      <ClerkProvider publishableKey={CLERK_KEY}>
        <I18nProvider>
          <ThemeProvider>
            <App hasAuth={true} />
          </ThemeProvider>
        </I18nProvider>
      </ClerkProvider>
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <I18nProvider>
        <ThemeProvider>
          <App hasAuth={false} />
        </ThemeProvider>
      </I18nProvider>
    </React.StrictMode>
  );
}
